/* Scroll is the clock. No timers, no idle RAF loop, and no scroll capture. */
(() => {
  const clamp = value => Math.max(0, Math.min(1, value));
  const boot = (scope = document) => {
    const scenes = scope.matches?.('[data-gg-underground-scene]') ? [scope] : scope.querySelectorAll('[data-gg-underground-scene]');
    scenes.forEach(scene => {
      if (scene.dataset.usReady || !('IntersectionObserver' in window)) return;
      const journey = scene.querySelector('.gg-us-journey');
      const stories = Array.from(scene.querySelectorAll('[data-us-story]'));
      const controls = Array.from(scene.querySelectorAll('[data-us-control]'));
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const small = matchMedia('(max-width: 719px)');
      const roots = Array.from(scene.querySelectorAll('[data-us-root]')).map(path => ({ path, length: path.getTotalLength(), start: +path.dataset.start, end: +path.dataset.end }));
      const travellers = Array.from(scene.querySelectorAll('[data-us-traveller]')).map(el => {
        const route = scene.querySelector('#' + el.dataset.route);
        return { el, route, length: route.getTotalLength(), offset: +el.dataset.offset, family: +el.dataset.family };
      });
      const ecosystem = scene.querySelector('.gg-us-ecosystem');
      const title = scene.querySelector('[data-us-scene-title]');
      const count = scene.querySelector('[data-us-count]');
      const labels = ['Roots start the exchange.', 'A food web keeps nutrients moving.', 'Certain bacteria can fix nitrogen.', 'Life needs a suitable home.'];
      let visible = false, frame = 0, disposed = false, active = -1;
      const draw = () => {
        frame = 0;
        if (disposed || document.hidden) return;
        const bounds = journey.getBoundingClientRect();
        const progress = clamp((innerHeight * .55 - bounds.top) / Math.max(1, bounds.height - innerHeight * .5));
        const focusLine = small.matches ? Math.max(innerHeight * .64, 54 + Math.min(320, innerHeight * .43) + 85) : innerHeight * .5;
        let next = 0;
        stories.forEach((story, index) => { if (story.getBoundingClientRect().top <= focusLine) next = index; });
        if (active !== next) {
          active = next; scene.dataset.usActive = String(next);
          title.textContent = labels[next]; count.textContent = '0' + (next + 1) + ' — 04';
          controls.forEach((link, index) => index === next ? link.setAttribute('aria-current', 'step') : link.removeAttribute('aria-current'));
        }
        scene.classList.toggle('gg-us-motionless', motion.matches);
        // The small-screen cutaway follows the story deeper into the root zone.
        ecosystem.setAttribute('viewBox', small.matches && !motion.matches ? `0 ${(15 + progress * 240).toFixed(1)} 740 500` : '0 0 740 790');
        ecosystem.setAttribute('preserveAspectRatio', motion.matches ? 'xMidYMid meet' : 'xMidYMid slice');
        scene.style.setProperty('--us-progress', String(progress));
        roots.forEach(({ path, length, start, end }) => {
          const growth = motion.matches ? 1 : clamp((.12 + progress * 1.18 - start) / (end - start));
          path.style.strokeDasharray = String(length);
          path.style.strokeDashoffset = String(length * (1 - growth));
        });
        travellers.forEach(({ el, route, length, offset, family }) => {
          const t = (progress * 3.4 + offset) % 1;
          const point = route.getPointAtLength(length * t);
          el.setAttribute('transform', `translate(${point.x.toFixed(2)} ${point.y.toFixed(2)})`);
          el.style.opacity = family === active && !motion.matches ? '1' : '0';
        });
      };
      const schedule = () => { if (visible && !document.hidden && !frame && !disposed) frame = requestAnimationFrame(draw); };
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (visible) schedule(); }, { rootMargin: '120px' });
      observer.observe(scene);
      scene.dataset.usReady = 'true';
      addEventListener('scroll', schedule, { passive: true });
      addEventListener('resize', schedule, { passive: true });
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener?.('change', draw);
      draw();
      const cleanup = event => {
        if (!event.target.contains(scene)) return;
        disposed = true; observer.disconnect();
        removeEventListener('scroll', schedule); removeEventListener('resize', schedule);
        document.removeEventListener('visibilitychange', schedule);
        motion.removeEventListener?.('change', draw);
        if (frame) cancelAnimationFrame(frame);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
